export var PriceDisplayType;
(function (PriceDisplayType) {
    PriceDisplayType["PRIMARY"] = "primary";
    PriceDisplayType["SECONDARY"] = "secondary";
    PriceDisplayType["PRIMARY_OPTIONS"] = "primaryOptions";
    PriceDisplayType["SECONDARY_OPTIONS"] = "secondaryOptions";
    PriceDisplayType["FINANCE"] = "finance";
})(PriceDisplayType || (PriceDisplayType = {}));
//# sourceMappingURL=PriceDisplayType.js.map